<!--
  * @Author: changyunxia
  * @Date:2020年10月10日 16:59:36
  * @LastEditors: changyunxia
  * @LastEditTime: @Date:2020年10月10日 16:59:36
  * @Description: 会议室预定 详情
  * @FilePath:@/components/HelloWorld.vue
-->
<template>
  <div>
    <div v-if="meetingData!==[]" class="meeting-time-title">
      <span>会议室{{ meetingData[0].room_code }}</span>
      <span v-if="time" class="meeting-line" />
      <span v-if="time" class="line">{{ timeDate }}</span>
    </div>

    <div class="meeting-time-flex">
      <div class="meeting-time " :class="time?'':'meetinh-time-flex1'">
        <ul>
          <li>08:30</li>
          <li>09:30</li>
          <li>10:30</li>
          <li>11:30</li>
          <li>12:30</li>
          <li>13:30</li>
          <li>14:30</li>
          <li>15:30</li>
          <li>16:30</li>
        </ul>
      </div>
      <div id="time" class="time-box " :class="time?'':'time-box-css'">
        <ul>
          <li v-for="(item , key) in list" ref="lists" :key="key"><a /></li>
        </ul>
      </div>
    </div>
  </div>

</template>

<script>

export default {
  name: 'MeetinDetails',
  components: {},
  props: {
    time: {
      type: Boolean,
      default: null
    },
    meetingData: {
      type: null,
      default: null
    },
    timeDate: {
      type: null,
      default: null
    },
    index: {
      type: null,
      default: null
    }
  },
  data() {
    return {
      list: new Array(36),
      meetingDetails: this.meetingData,
      colors: ['#7daaff', '#ede851', '#CCCCFF', '#99CC66', '#CCCC99', '#77e46c', '#99CCCC', '#996699', '#ffc77b', '#ff7d7d']

    }
  },
  computed: {},
  watch: {
    meetingData: {
      handler(newVal, oldVal) {
        this.meetingDetails = newVal
        this.$nextTick(() => {
          this.createFunc()
        })
      },
      immediate: true
    }
  },
  created() {

  },
  mounted() {
    this.$nextTick(() => {
      this.createFunc()
    })
  },
  methods: {
    bgNoneFunc() {
      const list = this.$refs.lists
      list.forEach((ele, i) => {
        this.$refs.lists[i].style.background = '#fafafa'
        this.$refs.lists[i].innerText = ''
      })
    },
    createFunc() {
      const list = this.$refs.lists
      this.meetingDetails.forEach((element, j) => {
        list.forEach((ele, i) => {
          // this.$refs.lists[i].style.background = 'none'
          if (i >= element.starNum && i <= element.endNum - 1) {
            // this.$refs.lists[i].style.background = element.color
            this.$refs.lists[i].style.background = this.colors[j]
            if (this.time) {
              this.$refs.lists[i].innerText = element.register_name
            }
          }
        })
      })
      // const chArr = document.body.getElementsByClassName('time')
      // for (let k = chArr.length - 1; k >= 0; k--) {
      //   // 删除元素 元素.parentNode.removeChild(元素);
      //   if (chArr[k] !== null) {
      //     chArr[k].parentNode.removeChild(chArr[k])
      //   }
      // }
      // var box = document.getElementById('time')
      // var box = document.body.getElementsByClassName('time-box')
      // console.log(box.length)
      // box.forEach((ele, i) => {
      //   var ul = document.createElement('ul') // 创建一个li标签time-box
      //   ul.classList.add('time')
      //   for (var h = 0; h < 36; h++) {
      //     // var li = document.createElement('li')
      //     // var a = document.createElement('a')
      //     // // li.innerHTML = h // 给li标签赋值
      //     // li.appendChild(a)
      //     // ul.appendChild(li)
      //     // if (Array.isArray(this.meetingDetails)) {
      //     // console.log(this.meetingDetails)
      //     this.meetingDetails.forEach(element => {
      //       if (h >= element.starNum && h <= element.endNum - 1) {
      //         // a.innerHTML = element.register_name
      //         // ul.childNodes[h].innerHTML = element.register_name
      //         ul.childNodes[h].style.backgroundColor = element.color
      //       }
      //     })
      //     // }
      //   }
      //   box[i].appendChild(ul)
      // })

      // 将创建好的li标签追加到box标签中
    }
  }
}
</script>

<style  lang='scss'>
.time-box{
  flex: 1;
  width: 100%;
  ul{
  width: 100%;
      display: flex;
    flex-wrap: wrap;
    li{
      width:25%;
      height: 18px;
       line-height: 18px;
      background: #fafafa;
      margin-bottom: 5px;
      text-align: center;
      color:#ffffff
    }
    font-size: 12px;
  }
}
</style>
<style lang='scss' scoped>
//@import url(); 引入公共css类
.meetinh-time-flex1{
  width: 100% !important;
  ul {
     margin-right:0 !important;
    display: flex;
    flex-wrap: wrap;
    li{
      width: 50% !important;
    }
  }
}

@media only screen and (max-width: 320px) {
   .time-box-css ul li{
     width: 8% !important
   }
}
@media screen and (min-width:330px) and (max-width:500px){
.time-box-css ul li{
     width: 9% !important
   }
}
@media screen and (min-width:501px) and (max-width:600px){
  .time-box-css ul li{
     width: 10% !important
   }
}
@media screen and (min-width:601px) and (max-width:768px){
  .time-box-css ul li{
     width: 10% !important
   }
   .time-box-css ul li:nth-child(4n+1){
      margin-left: 55px !important;
    }
}
@media screen and (min-width:770px) and (max-width:900px){
  .time-box-css ul li{
     width: 10% !important
   }
   .time-box-css ul li:nth-child(4n+1){
      margin-left: 60px !important;
    }
}
@media screen and (min-width:900px) and (max-width:1024px){
  .time-box-css ul li{
     width: 11% !important
   }
   .time-box-css ul li:nth-child(4n+1){
      margin-left: 50px !important;
    }
}
@media screen and (min-width:1025px) and (max-width:1366px){
  .time-box-css ul li{
     width: 11% !important
   }
   .time-box-css ul li:nth-child(4n+1){
      margin-left: 5% !important;
    }
}
@media only screen and (min-width: 1367px) {
   .time-box-css ul li{
     width: 11% !important
   }
   .time-box-css ul li:nth-child(4n+1){
      margin-left: 5% !important;
    }
}
.time-box-css{
  position: absolute;
  top: 0;
   width: 100%;
    // left: 45px;
  ul{
      height:112px;
    width: 100%;
  //     display: -webkit-flex; /* Safari */
  // -webkit-flex-flow: row-reverse wrap; /* Safari 6.1+ */
  display: flex;
    li{
     width: 9%;
      color: darkblue;
    }
    li:nth-child(4n+1){
      margin-left: 45px;
    }
  }
}
.meeting-time-title{
  display: flex;
  font-size: 16px;
  color: #1a1a1a;
  padding: 10px 14px;
  height: 25px;
    line-height: 20px;
    border-bottom: 1px solid #f8f8f8;
    margin-bottom: 10px;
  span{
    display: block;
  }
  .meeting-line{
    width: 2px;
    height: 16px;
    background: #1a1a1a;
    display: block;
    margin: 1px 20px;
  }
}
.meeting-time-flex{
  display: flex;
  width: 90%;
  margin: 0 auto;
position: relative;
  .meeting-time{
    width: 44px;
    ul{
      margin-right: 15px;
      li{
        font-size: 14px;
        color: #8e8e8e;
        height:18px;
        line-height: 18px;
        margin-bottom: 5px;
      }
    }
  }
}
</style>
